import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { htmlSafe } from '@ember/template';
import { guidFor } from '@ember/object/internals';

export default class PaperDataTableRow extends Component {
  // Stable DOM id so the row-level edit dialog can locate this row.
  elementId = guidFor(this);
  @tracked showEdit = false;

  get style() {
    if (this.args.onClick || this.args.edit) {
      return htmlSafe('cursor: pointer;');
    }
    return htmlSafe('');
  }

  @action
  handleClick() {
    if (this.args.onClick) {
      this.args.onClick();
    }
    if (this.args.edit) {
      this.showEdit = true;
    }
  }

  @action
  close() {
    if (this.args.onClose) {
      this.args.onClose(this);
    }
  }

  @action
  toggleEdit() {
    this.showEdit = !this.showEdit;
  }
}
